import Vue from 'vue';
import i18n from "@/i18n";
import store from "@/store";
import vuetify from './plugins/vuetify';

function shopName() {
  return store.state.settings && store.state.settings.shop_custom_name
    ? store.state.settings.shop_custom_name
    : i18n.t("Shop.default_shop_name");
}
function setShopName(str) {
  return i18n.t(str, [shopName()])
}
Vue.filter('setShopName', setShopName);

function allianceName() {
  return store.state.settings && store.state.settings.agent_custom_name
    ? store.state.settings.agent_custom_name
    : i18n.t("Alliances.default_alliance_name");
}
function setAllianceName(str) {
  return i18n.t(str, [allianceName()])
}
Vue.filter('setAllianceName', setAllianceName);
function maxValue(){
  return 99999999;
}
function setMaxValue(num) {
  return i18n.t(num, [maxValue()])
}
Vue.filter('setMaxValue', setMaxValue);

var stockOrderOUTStatus = [
  {
    text: i18n.t("stockOutOrders.status.new"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("stockOutOrders.status.granted"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("stockOutOrders.status.finished"),
    color: "primary",
    textColor: "white",
    value: 3,
  },
];
// 查找Stock Order Status
function stockOrderOUTStatusItem(value) {
  var item = stockOrderOUTStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function stockOrderOUTStatusText(value) {
  return stockOrderOUTStatusItem(value).text;
}
Vue.filter('stockOrderOUTStatusText', stockOrderOUTStatusText);
function stockOrderOUTStatusColor(value) {
  return stockOrderOUTStatusItem(value).color;
}
Vue.filter('stockOrderOUTStatusColor', stockOrderOUTStatusColor);
function stockOrderOUTStatusTextColor(value) {
  return vuetify.dark ? stockOrderOUTStatusItem(value).textColor : '';
}
Vue.filter('stockOrderOUTStatusTextColor', stockOrderOUTStatusTextColor);

var cancelFlgs = [
  {
    text: i18n.t("CancelFlgs.off"),
    color: "primary",
    textColor: "white",
    value: 0
  },
  {
    text: i18n.t("CancelFlgs.on"),
    color: "grey",
    textColor: "white",
    value: 1
  }
];
// 查找cancelFlgs
function cancelFlgsItem(value) {
  value = value ? 1 : 0;// 有值都当on
  return cancelFlgs.find((element) => element.value == value);
}
function cancelFlgsText(value) {
  return cancelFlgsItem(value).text;
}
Vue.filter('cancelFlgsText', cancelFlgsText);
function cancelFlgsColor(value) {
  return cancelFlgsItem(value).color;
}
Vue.filter('cancelFlgsColor', cancelFlgsColor);
function cancelFlgsTextColor(value) {
  return cancelFlgsItem(value).textColor;
}
Vue.filter('cancelFlgsTextColor', cancelFlgsTextColor);

//查找出库类型
var stockOrderOUTTypes = [
  {
    text: i18n.t("stockOutOrders.types.order"),
    value: 1,
  },
  {
    text: i18n.t("stockOutOrders.types.requisition"),
    value: 2,
  },
  {
    text: i18n.t("stockOutOrders.types.stock_taking"),
    value: 3,
  },
  {
    text: i18n.t("stockOutOrders.types.normal_two"),
    value: 12,
  },
  {
    text: i18n.t("stockOutOrders.types.normal_one"),
    value: 11,
  },
  {
    text: i18n.t("stockOutOrders.types.return"),
    value: 13,
  },
  {
    text: i18n.t("stockOutOrders.types.other_stock_out"),
    value: 14,
  },
];
function stockOrderOUTTypesItem(value) {
  var item = stockOrderOUTTypes.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}

function stockOrderOUTTypesText(value) {
  return stockOrderOUTTypesItem(value).text;
}
Vue.filter('stockOrderOUTTypesText', stockOrderOUTTypesText);
function stockOrderOUTTypesColor(value) {
  return stockOrderOUTTypesItem(value).color;
}
Vue.filter('stockOrderOUTTypesColor', stockOrderOUTTypesColor);
function stockOrderOUTTypesTextColor(value) {
  return stockOrderOUTTypesItem(value).textColor;
}
Vue.filter('stockOrderOUTTypesTextColor', stockOrderOUTTypesTextColor);

var stockOrderOUTBrokenType = [
  {
    text: i18n.t("stockOutOrders.brokenTypes.program"),
    value: 1,
  },
  {
    text: i18n.t("stockOutOrders.brokenTypes.production"),
    value: 2,
  },
  {
    text: i18n.t("stockOutOrders.brokenTypes.marketing"),
    value: 3,
  },
  {
    text: i18n.t("stockOutOrders.brokenTypes.other"),
    value: 4,
  },
  {
    text: i18n.t("stockOutOrders.brokenTypes.loss"),
    value: 5,
  },
];
function stockOrderOUTBrokenTypeItem(value) {
  var item = stockOrderOUTBrokenType.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function stockOrderOUTBrokenTypeText(value) {
  return stockOrderOUTBrokenTypeItem(value).text;
}
Vue.filter('stockOrderOUTBrokenTypeText', stockOrderOUTBrokenTypeText);

// 退货单状态
var returnOrderStatus = [
  {
    text: i18n.t("ReturnOrder.status.new"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("ReturnOrder.status.confirmed"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("ReturnOrder.status.granted"),
    color: "primary",
    textColor: "white",
    value: 3,
  },
  {
    text: i18n.t("ReturnOrder.status.finished"),
    color: "primary",
    textColor: "white",
    value: 4,
  },
];
// 查找Status
function returnOrderStatusItem(value) {
  var item = returnOrderStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function returnOrderStatusText(value) {
  return returnOrderStatusItem(value).text;
}
Vue.filter('returnOrderStatusText', returnOrderStatusText);
function returnOrderStatusColor(value) {
  return returnOrderStatusItem(value).color;
}
Vue.filter('returnOrderStatusColor', returnOrderStatusColor);
function returnOrderStatusTextColor(value) {
  return returnOrderStatusItem(value).textColor;
}
Vue.filter('returnOrderStatusTextColor', returnOrderStatusTextColor);

var stockOrderINStatus = [
  {
    text: i18n.t("stockInOrders.status.new"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("stockInOrders.status.granted"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("stockInOrders.status.finished"),
    color: "primary",
    textColor: "white",
    value: 3,
  },
];
// 查找Stock Order Status
function stockOrderINStatusItem(value) {
  var item = stockOrderINStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function stockOrderINStatusText(value) {
  return stockOrderINStatusItem(value).text;
}
Vue.filter('stockOrderINStatusText', stockOrderINStatusText);
function stockOrderINStatusColor(value) {
  return stockOrderINStatusItem(value).color;
}
Vue.filter('stockOrderINStatusColor', stockOrderINStatusColor);
function stockOrderINStatusTextColor(value) {
  return stockOrderINStatusItem(value).textColor;
}
Vue.filter('stockOrderINStatusTextColor', stockOrderINStatusTextColor);

// 查找当前库存商品是否为原材料
var stockMaterialsIsRaw = [
  {
    text: i18n.t("CurrentStocks.rawMaterial.yes"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("CurrentStocks.rawMaterial.no"),
    color: "primary",
    textColor: "white",
    value: 0,
  },
];

// 查找入库类型
var stockOrderINTypes = [
  {
    text: i18n.t("stockInOrders.types.return_order_in"),
    value: 1,
  },
  {
    text: i18n.t("stockInOrders.types.examines_in"),
    value: 2,
  },
  {
    text: i18n.t("stockInOrders.types.stock_taking_in"),
    value: 3,
  },
  {
    text: i18n.t("stockInOrders.types.init_stock_in"),
    value: 5,
  },
  {
    text: i18n.t("stockInOrders.types.requisition_in"),
    value: 6,
  },
  {
    text: i18n.t("stockInOrders.types.normal_one_in"),
    value: 11,
  },
  {
    text: i18n.t("stockInOrders.types.other_in"),
    value: 14,
  },
]
function stockOrderINTypesItem(value) {
  var item = stockOrderINTypes.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}

function stockOrderINTypesText(value) {
  return stockOrderINTypesItem(value).text;
}
Vue.filter('stockOrderINTypesText', stockOrderINTypesText);
function stockOrderINTypesColor(value) {
  return stockOrderINTypesItem(value).color;
}
Vue.filter('stockOrderINTypesColor', stockOrderINTypesColor);
function stockOrderINTypesTextColor(value) {
  return stockOrderINTypesItem(value).textColor;
}
Vue.filter('stockOrderINTypesTextColor', stockOrderINTypesTextColor);

//盘点单状态
var stockTakeOrderStatus = [
  {
    text: i18n.t("StockTakes.orderStatus.wait_stock_take"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("StockTakes.orderStatus.already_stock_take"),
    color: "primary",
    textColor: "white",
    value: 2,
  }
];
function stockTakeOrderStatusItem(value) {
  var item = stockTakeOrderStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function stockTakeOrderStatusText(value) {
  return stockTakeOrderStatusItem(value).text;
}
Vue.filter('stockTakeOrderStatusText', stockTakeOrderStatusText);
function stockTakeOrderStatusColor(value) {
  return stockTakeOrderStatusItem(value).color;
}
Vue.filter('stockTakeOrderStatusColor', stockTakeOrderStatusColor);
function stockTakeOrderStatusTextColor(value) {
  return stockTakeOrderStatusItem(value).textColor;
}
Vue.filter('stockTakeOrderStatusTextColor', stockTakeOrderStatusTextColor);

// 冻结状态
var prohibitFlgs = [
  {
    text: i18n.t("StockDetails.prohibit_flg.on"),
    color: "primary",
    textColor: "white",
    value: 0
  },
  {
    text: i18n.t("StockDetails.prohibit_flg.off"),
    color: "danger",
    textColor: "white",
    value: 1
  }
];
// 查找prohibitFlgs
function prohibitFlgsItem(value){
  var item = prohibitFlgs.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  }
}
function prohibitFlgsText(value){
  return prohibitFlgsItem(value).text;
}
Vue.filter('prohibitFlgsText',prohibitFlgsText)
function prohibitFlgsColor(value){
  return prohibitFlgsItem(value).color;
}
Vue.filter('prohibitFlgsColor',prohibitFlgsColor);
function prohibitFlgsTextColor(value){
  return prohibitFlgsItem(value).textColor
}
Vue.filter('prohibitFlgsTextColor', prohibitFlgsTextColor)
// 过期状态
var expiredFlgs = [
  {
    text: i18n.t("StockDetails.expired_status.on"),
    color: "primary",
    textColor: "white",
    value: 0
  },
  {
    text: i18n.t("StockDetails.expired_status.off"),
    color: "danger",
    textColor: "white",
    value: 1
  }
];
function expiredFlgsItem(value) {
  var item = expiredFlgs.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  }
}
function expiredFlgsText(value) {
  return expiredFlgsItem(value).text;
}
Vue.filter('expiredFlgsText', expiredFlgsText)
function expiredFlgsColor(value) {
  return expiredFlgsItem(value).color
}
Vue.filter('expiredFlgsColor', expiredFlgsColor)
function expiredFlgsTextColor(value) {
  return expiredFlgsItem(value).textColor
}
Vue.filter('expiredFlgsTextColor', expiredFlgsTextColor)

// 使用状态
var useStatus = [
  {
    text: i18n.t("StockDetails.use_status.off"),
    color:"primary",
    textColor:"white",
    value: 0
  },
  {
    text: i18n.t("StockDetails.use_status.on_off"),
    color:"primary",
    textColor:"white",
    value: 2
  },
  {
    text: i18n.t("StockDetails.use_status.on"),
    color:"",
    textColor:"",
    value: 1
  }
]
// 查找UseStatus
function useStatusItem(value){
  var item = useStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  }
}
function useStatusText(value){
  return useStatusItem(value).text;
}
Vue.filter('useStatusText', useStatusText)
function useStatusColor(value){
  return useStatusItem(value).color
}
Vue.filter('useStatusColor',useStatusColor)
function useStatusTextColor(value){
  return useStatusItem(value).textColor
}
Vue.filter('useStatusTextColor',useStatusTextColor)

// 出/入库类型
var outInFlgs = [
  {
    text: i18n.t("stockOrderAnalyze.type.out"),
    color: "danger",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("stockOrderAnalyze.type.in"),
    color: "primary",
    textColor: "white",
    value: 2,
  }
];
// 查找
function outInFlgsItem(value) {
  var item = outInFlgs.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function outInFlgsText(value){
  return outInFlgsItem(value).text;
}
Vue.filter('outInFlgsText',outInFlgsText);
function outInFlgsColor(value){
  return outInFlgsItem(value).color;
}
Vue.filter('outInFlgsColor',outInFlgsColor);
function outInFlgsTextColor(value){
  return outInFlgsItem(value).textColor;
}
Vue.filter('outInFlgsTextColor',outInFlgsTextColor)

//生产计划单状态
var productionPlansStatus = [
  {
    text: i18n.t("ProductionPlans.productionPlansStatus.wait_approve"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("ProductionPlans.productionPlansStatus.wait_stock_out"),
    color: "primary",
    textColor: "white",
    value: 3,
  },
  {
    text: i18n.t("ProductionPlans.productionPlansStatus.wait_stock_in"),
    color: "primary",
    textColor: "white",
    value: 4,
  },
  {
    text: i18n.t("ProductionPlans.productionPlansStatus.finished"),
    color: "primary",
    textColor: "white",
    value: 5,
  },
];
function productionPlansStatusItem(value) {
  var item = productionPlansStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function productionPlansStatusText(value) {
  return productionPlansStatusItem(value).text;
}
Vue.filter('productionPlansStatusText', productionPlansStatusText);
function productionPlansStatusColor(value) {
  return productionPlansStatusItem(value).color;
}
Vue.filter('productionPlansStatusColor', productionPlansStatusColor);
function productionPlansStatusTextColor(value) {
  return productionPlansStatusItem(value).textColor;
}
Vue.filter('productionPlansStatusTextColor', productionPlansStatusTextColor);

//生产计划单类型
var productionPlansType = [
  {
    text: i18n.t("ProductionPlans.productionType.production_combined"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("ProductionPlans.productionType.production_split"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
];
function productionPlansTypeItem(value) {
  var item = productionPlansType.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function productionPlansTypeText(value) {
  return productionPlansTypeItem(value).text;
}
Vue.filter('productionPlansTypeText', productionPlansTypeText);
function productionPlansTypeColor(value) {
  return productionPlansTypeItem(value).color;
}
Vue.filter('productionPlansTypeColor', productionPlansTypeColor);
function productionPlansTypeTextColor(value) {
  return productionPlansTypeItem(value).textColor;
}
Vue.filter('productionPlansTypeTextColor', productionPlansTypeTextColor);

function getDayStart() {
  var from = new Date();
  from.setHours(0, 0, 0, 0);
  return from;
}
function getDayEnd() {
  var end = new Date();
  end.setHours(23, 59, 59, 999);
  return end;
}

var orderStatus = [
  {
    text: i18n.t("Order.status.new"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("Order.status.out_stock"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("Order.status.out_stock"),
    color: "primary",
    textColor: "white",
    value: 3,
  },
  {
    text: i18n.t("Order.status.distributed"),
    color: "primary",
    textColor: "white",
    value: 4,
  },
  {
    text: i18n.t("Order.status.distributed"),
    color: "primary",
    textColor: "white",
    value: 5,
  },
  {
    text: i18n.t("Order.status.finished"),
    color: "primary",
    textColor: "white",
    value: 6,
  },
];
// 查找Status
function orderStatusItem(value) {
  var item = orderStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function orderStatusText(value) {
  return orderStatusItem(value).text;
}
Vue.filter('orderStatusText', orderStatusText);
function orderStatusColor(value) {
  return orderStatusItem(value).color;
}
Vue.filter('orderStatusColor', orderStatusColor);
function orderStatusTextColor(value) {
  return orderStatusItem(value).textColor;
}
Vue.filter('orderStatusTextColor', orderStatusTextColor);

var billPayFlgs = [
  {
    text: i18n.t("Bill.payFlgs.unpay"),
    color: "accent",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("Bill.payFlgs.pay_apart"),
    color: "accent",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("Bill.payFlgs.paid"),
    color: "primary",
    textColor: "white",
    value: 3,
  },
];
// 查找PayFlgs
function billPayFlgsItem(value) {
  var item = billPayFlgs.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}

// 订单来源
function orderOriginFlgs() {
  return [
    {
      text: i18n.t("Order.originFlgs.account"),
      value: "001",
    },
    {
      text: i18n.t("Order.originFlgs.shop", [shopName()]),
      value: "002",
    },
    {
      text: i18n.t("Order.originFlgs.shop_android"),
      value: "101",
    },
    {
      text: i18n.t("Order.originFlgs.shop_ios"),
      value: "102",
    },
    {
      text: i18n.t("Order.originFlgs.wechat_applet"),
      value: "103",
    },
    {
      text: i18n.t("Order.originFlgs.agent_android"),
      value: "201",
    },
    {
      text: i18n.t("Order.originFlgs.api2_shop", [shopName()]),
      value: "301",
    },
    {
      text: i18n.t("Order.originFlgs.api2_buyer"),
      value: "302",
    },
    {
      text: i18n.t("Order.originFlgs.weimob"),
      value: "401",
    },
    {
      text: i18n.t("Order.originFlgs.excel_buyer_import"),
      value: "402",
    },
    {
      text: i18n.t("Order.originFlgs.excel_import"),
      value: "003",
    },
    {
      text: i18n.t("Order.originFlgs.purchase"),
      value: "501",
    },
    {
      text: i18n.t("Order.originFlgs.default"),
      value: "000",
    },
  ];
}
// 查找OriginFlgs
function orderOriginFlgsItem(value) {
  var item = orderOriginFlgs().find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Order.originFlgs.default"),
    value: "000",
  };
}
function orderOriginFlgsText(value) {
  return orderOriginFlgsItem(value).text;
}
Vue.filter('orderOriginFlgsText', orderOriginFlgsText);
function orderOriginFlgsColor() {
  return "";
}
Vue.filter('orderOriginFlgsColor', orderOriginFlgsColor);
function orderOriginFlgsTextColor() {
  return "";
}
Vue.filter('orderOriginFlgsTextColor', orderOriginFlgsTextColor);
function billPayFlgsText(value) {
  return billPayFlgsItem(value).text;
}
Vue.filter('billPayFlgsText', billPayFlgsText);
function billPayFlgsColor(value) {
  return billPayFlgsItem(value).color;
}
Vue.filter('billPayFlgsColor', billPayFlgsColor);
function billPayFlgsTextColor(value) {
  return billPayFlgsItem(value).textColor;
}
Vue.filter('billPayFlgsTextColor', billPayFlgsTextColor);

// 账单状态
var billStatus = [
  {
    text: i18n.t("Bill.status.new"),
    color: "gray",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("Bill.status.finished"),
    color: "primary",
    textColor: "white",
    value: 3,
  },
];
// 查找Bill Status
function billStatusItem(value) {
  var item = billStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function billStatusText(value) {
  return billStatusItem(value).text;
}
Vue.filter('billStatusText', billStatusText);
function billStatusColor(value) {
  return billStatusItem(value).color;
}
Vue.filter('billStatusColor', billStatusColor);
function billStatusTextColor(value) {
  return billStatusItem(value).textColor;
}
Vue.filter('billStatusTextColor', billStatusTextColor);

var examineStatus = [
  {
    text: i18n.t("Examine.status.distributed"),
    color: "accent",
    textColor: "white",
    value: 0,
  },
  {
    text: i18n.t("Examine.status.finished"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
];
// 查找Examine Status
function examineStatusItem(value) {
  var item = examineStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function examineStatusText(value) {
  return examineStatusItem(value).text;
}
Vue.filter('examineStatusText', examineStatusText);
function examineStatusColor(value) {
  return examineStatusItem(value).color;
}
Vue.filter('examineStatusColor', examineStatusColor);
function examineStatusTextColor(value) {
  return examineStatusItem(value).textColor;
}
Vue.filter('examineStatusTextColor', examineStatusTextColor);

// 查找Examine Flgs
var examineFlgs = [
  {
    text: i18n.t("Examine.examineFlgs.examine_flg_wait"),
    color: "accent",
    textColor: "white",
    value: 0,
  },
  {
    text: i18n.t("Examine.examineFlgs.examine_flg_shop"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("Examine.examineFlgs.examine_flg_account"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("Examine.examineFlgs.examine_flg_system"),
    color: "primary",
    textColor: "white",
    value: 3,
  },
  {
    text: i18n.t("Examine.examineFlgs.examine_flg_agent"),
    color: "primary",
    textColor: "white",
    value: 4,
  },
];
function examineFlgsItem(value) {
  var item = examineFlgs.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function examineFlgsText(value) {
  return examineFlgsItem(value).text;
}
Vue.filter('examineFlgsText', examineFlgsText);
function examineFlgsColor(value) {
  return examineFlgsItem(value).color;
}
Vue.filter('examineFlgsColor', examineFlgsColor);
function examineFlgsTextColor(value) {
  return examineFlgsItem(value).textColor;
}
Vue.filter('examineFlgsTextColor', examineFlgsTextColor);

// 查找Examine AbnormalFlgs
var examineAbnormalFlgs = [
  {
    text: i18n.t("Examine.abnormalFlgs.normal"),
    color: "primary",
    textColor: "white",
    value: 0,
  },
  {
    text: i18n.t("Examine.abnormalFlgs.abnormal"),
    color: "accent",
    textColor: "white",
    value: 1,
  },
];
function examineAbnormalFlgsItem(value) {
  var item = examineAbnormalFlgs.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function examineAbnormalFlgsText(value) {
  return examineAbnormalFlgsItem(value).text;
}
Vue.filter('examineAbnormalFlgsText', examineAbnormalFlgsText);
function examineAbnormalFlgsColor(value) {
  return examineAbnormalFlgsItem(value).color;
}
Vue.filter('examineAbnormalFlgsColor', examineAbnormalFlgsColor);
function examineAbnormalFlgsTextColor(value) {
  return examineAbnormalFlgsItem(value).textColor;
}
Vue.filter('examineAbnormalFlgsTextColor', examineAbnormalFlgsTextColor);

// 查找Examine AbnormalFlgs,异常处理状态
var examineIsAbnormaled = [
  {
    text: i18n.t("Examine.abnormalFlgs.normal"),
    color: "primary",
    textColor: "white",
    value: 0,
  },
  {
    text: i18n.t("Examine.abnormalFlgs.abnormal_untreaded"),
    color: "accent",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("Examine.abnormalFlgs.abnormal_handeld"),
    color: "accent",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("Examine.abnormalFlgs.abnormal_complete"),
    color: "accent",
    textColor: "white",
    value: 3,
  },
];
function examineIsAbnormaledItem(value) {
  var item = examineIsAbnormaled.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function examineIsAbnormaledText(value) {
  return examineIsAbnormaledItem(value).text;
}
Vue.filter('examineIsAbnormaledText', examineIsAbnormaledText);
function examineIsAbnormaledColor(value) {
  return examineIsAbnormaledItem(value).color;
}
Vue.filter('examineIsAbnormaledColor', examineIsAbnormaledColor);
function examineIsAbnormaledTextColor(value) {
  return examineIsAbnormaledItem(value).textColor;
}
Vue.filter('examineIsAbnormaledTextColor', examineIsAbnormaledTextColor);

// 对账单类型（要货对账单，门店退货对账单）
var billTypes = [
  {
    text: i18n.t("ReceiptBillAnalyze.billTypes.billTypeShop"),
    color: "primary",
    textColor: "white",
    value: 101,
  },
  {
    text: i18n.t("ReceiptBillAnalyze.billTypes.billTypeReturn"),
    color: "primary",
    textColor: "white",
    value: 102,
  }
]
function billTypesItem(value) {
  var item = billTypes.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function billTypesText(value) {
  return billTypesItem(value).text;
}
Vue.filter('billTypesText', billTypesText);
function billTypesColor(value) {
  return billTypesItem(value).color;
}
Vue.filter('billTypesColor', billTypesColor);
function billTypesTextColor(value) {
  return billTypesItem(value).textColor;
}
Vue.filter('billTypesTextColor', billTypesTextColor);

// 财务状态
var financeFlgs = [
  {
    text: i18n.t("ReceiptBillAnalyze.payFlgs.unpay"),
    color: "danger",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("ReceiptBillAnalyze.payFlgs.pay_apart"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("ReceiptBillAnalyze.payFlgs.paid"),
    color: "primary",
    textColor: "white",
    value: 3,
  }
];
function financeFlgsItem(value) {
  var item = financeFlgs.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function financeFlgsText(value) {
  return financeFlgsItem(value).text;
}
Vue.filter('financeFlgsText', financeFlgsText);
function financeFlgsColor(value) {
  return financeFlgsItem(value).color;
}
Vue.filter('financeFlgsColor', financeFlgsColor);
function financeFlgsTextColor(value) {
  return financeFlgsItem(value).textColor;
}
Vue.filter('financeFlgsTextColor', financeFlgsTextColor);

// 对账状态
var billCheckFlg = [
  {
    text: i18n.t("ReceiptBillAnalyze.billCheckFlg.new"),
    color: "primary",
    textColor: "white",
    value: 0,
  },
  {
    text: i18n.t("ReceiptBillAnalyze.billCheckFlg.finished"),
    color: "primary",
    textColor: "white",
    value: 1,
  }
]
function billCheckFlgItem(value) {
  var item = billCheckFlg.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function billCheckFlgText(value) {
  return billCheckFlgItem(value).text;
}
Vue.filter('billCheckFlgText', billCheckFlgText);
function billCheckFlgColor(value) {
  return billCheckFlgItem(value).color;
}
Vue.filter('billCheckFlgColor', billCheckFlgColor);
function billCheckFlgTextColor(value) {
  return billCheckFlgItem(value).textColor;
}
Vue.filter('billCheckFlgTextColor', billCheckFlgTextColor);

// 归账状态
var billFlgs = [
  {
    text: i18n.t("ReceiptBillAnalyze.billStatus.finished"),
    color: "primary",
    textColor: "white",
    value: 3,
  },
  {
    text: i18n.t("ReceiptBillAnalyze.billStatus.new"),
    color: "primary",
    textColor: "white",
    value: 1,
  }
]
function billFlgsItem(value) {
  var item = billFlgs.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function billFlgsText(value) {
  return billFlgsItem(value).text;
}
Vue.filter('billFlgsText', billFlgsText);
function billFlgsColor(value) {
  return billFlgsItem(value).color;
}
Vue.filter('billFlgsColor', billFlgsColor);
function billFlgsTextColor(value) {
  return billFlgsItem(value).textColor;
}
Vue.filter('billFlgsTextColor', billFlgsTextColor);

// 是否超收/超付
var beyondStatus = [
  {
    text: i18n.t("Receipt.beyondStatus.no"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("Receipt.beyondStatus.overcharge"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("Receipt.beyondStatus.overpay"),
    color: "primary",
    textColor: "white",
    value: 3,
  }
];
function beyondStatusItem(value) {
  var item = beyondStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function beyondStatusText(value) {
  return beyondStatusItem(value).text;
}
Vue.filter('beyondStatusText', beyondStatusText);
function beyondStatusColor(value) {
  return beyondStatusItem(value).color;
}
Vue.filter('beyondStatusColor', beyondStatusColor);
function beyondStatusTextColor(value) {
  return beyondStatusItem(value).textColor;
}
Vue.filter('beyondStatusTextColor', beyondStatusTextColor);

// 退款
var operationType = [
  {
    text: i18n.t("ReceiptDetail.operation_type"),
    color: "action",
    textColor: "white",
    value: 203,
  },
  {
    text: i18n.t("ReceiptDetail.reverse"),
    color: "danger",
    textColor: "white",
    value: 901,
  },
]
function operationTypeItem(value) {
  var item = operationType.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function operationTypeText(value) {
  return operationTypeItem(value).text;
}
Vue.filter('operationTypeText', operationTypeText);
function operationTypeColor(value) {
  return operationTypeItem(value).color;
}
Vue.filter('operationTypeColor', operationTypeColor);
function operationTypeTextColor(value) {
  return operationTypeItem(value).textColor;
}
Vue.filter('operationTypeTextColor', operationTypeTextColor);

export default {
  shopName,
  allianceName,
  maxValue,
  limitAll: 10000000,
  cancelFlgs,
  prohibitFlgs,
  stockMaterialsIsRaw,
  outInFlgs,
  billTypes,
  financeFlgs,
  billCheckFlg,
  billFlgs,
  beyondStatus,
  operationType,
  stock_out_order: {
    status: stockOrderOUTStatus,
    types: stockOrderOUTTypes,
    brokenType: stockOrderOUTBrokenType,
  },
  stock_in_order: {
    status: stockOrderINStatus,
    types: stockOrderINTypes
  },
  stockTakeOrder: {
    status: stockTakeOrderStatus,
  },
  use: {
    use_status: useStatus
  },
  order: {
    status: orderStatus
  },
  bill: {
    pay_flgs: billPayFlgs
  },
  examine: {
    status: examineStatus,
    abnormal_flgs: examineAbnormalFlgs,
    examine_flgs: examineFlgs,
  },
  pruductionPlan: {
    status: productionPlansStatus,
    type: productionPlansType,
  },
  return_order: {
    status: returnOrderStatus
  },
  dateTimeRangeShortcuts: [
    {
      text: i18n.t("$datetime.shortcuts.today"),
      onClick: () => {
        return [getDayStart(), getDayEnd()];
      },
    },
    {
      text: i18n.t("$datetime.shortcuts.yesterday"),
      onClick: () => {
        const from = getDayStart();
        const end = getDayEnd();
        from.setDate(from.getDate() - 1);
        end.setDate(end.getDate() - 1);
        return [from, end];
      },
    },
    {
      text: i18n.t("$datetime.shortcuts.inOneWeek"),
      onClick: () => {
        const from = getDayStart();
        const end = getDayEnd();
        from.setDate(from.getDate() - 6);
        return [from, end];
      },
    },
    {
      text: i18n.t("$datetime.shortcuts.inOneMonth"),
      onClick: () => {
        const from = getDayStart();
        const end = getDayEnd();
        from.setMonth(from.getMonth() - 1);
        from.setDate(from.getDate() + 1);
        return [from, end];
      },
    },
    // {
    //   text: i18n.t("$datetime.shortcuts.inHalfYear"),
    //   onClick: () => {
    //     const from = getDayStart();
    //     const end = getDayEnd();
    //     from.setMonth(from.getMonth() - 6);
    //     from.setDate(from.getDate() + 1);
    //     return [from, end];
    //   },
    // },
    // {
    //   text: i18n.t("$datetime.shortcuts.inOneYear"),
    //   onClick: () => {
    //     const from = getDayStart();
    //     const end = getDayEnd();
    //     from.setFullYear(from.getFullYear() - 1);
    //     from.setDate(from.getDate() + 1);
    //     return [from, end];
    //   },
    // },
    {
      text: i18n.t("$datetime.shortcuts.thisWeek"),
      onClick: () => {
        const from = getDayStart();
        const end = getDayEnd();
        var day = from.getDay()
        if (day == 0) {
           day = 7
         }
        from.setDate(from.getDate() - day + 1);
        end.setDate(end.getDate() + 7 - day);
        return [from, end];
      },
    },
    {
      text: i18n.t("$datetime.shortcuts.lastWeek"),
      onClick: () => {
        const from = getDayStart();
        const end = getDayEnd();
        var day = from.getDay()
        if (day == 0) {
          day = 7
        }
        from.setDate(from.getDate() - 6 - day);
        end.setDate(end.getDate() - day);
        return [from, end];
      },
    },
    {
      text: i18n.t("$datetime.shortcuts.thisMonth"),
      onClick: () => {
        const from = getDayStart();
        const end = getDayEnd();
        from.setDate(1);
        end.setMonth(end.getMonth() + 1);
        end.setDate(0);
        return [from, end];
      },
    },
    {
      text: i18n.t("$datetime.shortcuts.lastMonth"),
      onClick: () => {
        const from = getDayStart();
        const end = getDayEnd();
        from.setDate(1);
        from.setMonth(from.getMonth() - 1);
        end.setDate(0);
        return [from, end];
      },
    },
    {
      text: i18n.t("$datetime.shortcuts.thisYear"),
      onClick: () => {
        const from = getDayStart();
        const end = getDayEnd();
        from.setMonth(0);
        from.setDate(1);
        end.setFullYear(end.getFullYear() + 1);
        end.setMonth(0);
        end.setDate(0);
        return [from, end];
      },
    },
    {
      text: i18n.t("$datetime.shortcuts.lastYear"),
      onClick: () => {
        const from = getDayStart();
        const end = getDayEnd();
        from.setMonth(0);
        from.setDate(1);
        from.setFullYear(from.getFullYear() - 1);
        end.setMonth(0);
        end.setDate(0);
        return [from, end];
      },
    },
  ],
  tableOptions: {
    groupBy: [],
    groupDesc: [],
    itemsPerPage: 30,
    multiSort: true,
    mustSort: false,
    page: 1,
    sortBy: [],
    sortDesc: [],
  },
}